"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tags = exports.polishTranslate = exports.places = exports.rooms = void 0;
exports.rooms = ["bedroom", "living-room", "corridor", "carriage-room"];
exports.places = {
  bedroom: ["wardrobe", "chest-of-drawers"],
  "living-room": ["sofa", "tv-cupboard", "chest-of-drawers"],
  corridor: ["wardrobe", "chest-of-drawers"],
  "carriage-room": ["long-cupboard", "bookcase", "desk", "tv-cupboard"],
};
exports.polishTranslate = {
  bedroom: "sypialnia",
  "living-room": "salon",
  corridor: "korytarz",
  "carriage-room": "pokój-wagon",
  wardrobe: "szafa",
  "chest-of-drawers": "komoda",
  sofa: "sofa",
  "tv-cupboard": "szafka TV",
  "long-cupboard": "długa szafka",
  bookcase: "regał",
  desk: "biurko",
  crime: "kryminał",
  thriller: "thriller",
  food: "jedzenie",
  school: "do szkoły",
  youth: "młodzieżowa",
  detective: "detektywistyczna",
  science: "nauka",
  fantasy: "fantasy",
  publicistic: "publicystyka",
  kids: "dla dzieci",
  series: "cykl",
  beauty: "piękna",
  "sci-fi": "sci-fi",
  horror: "horror",
  adventure: "przygodowa",
  fact: "fakt",
  biography: "biografia",
  sport: "sport",
  classic: "klasyka",
  moral: "obyczajowa",
  art: "sztuka",
  travel: "podróże",
};
exports.tags = [
  "crime",
  "thriller",
  "food",
  "school",
  "youth",
  "detective",
  "science",
  "fantasy",
  "series",
  "biography",
  "publicistic",
  "kids",
  "beauty",
  "sci-fi",
  "horror",
  "sport",
  "adventure",
  "fact",
  "classic",
  "moral",
  "art",
  "travel",
];
